import React, { Fragment, useContext, useEffect, useState } from "react";
import { MsalContext } from '../Contexts/MsalContext';
import { APIContext } from '../Contexts/APIContext';
import ClientReportViewModel from "../PowerBIReport/ViewModels/FlagstoneClientReportModel";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import UpdateIcon from '@mui/icons-material/Update';
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from '@mui/icons-material/Delete';
import AddEditClientReportDialog from "./AddEditClientReportDialog";
import Button from "@mui/material/Button";

export default function ClientReportSelectionContainer() {
    const { msalFetch } = useContext(MsalContext);
    const [data, setData] = useState<ClientReportViewModel[]>([]);
    const [open, setOpen] = useState(false);
    const [searchParams, setSearchParams] = useState("");
    const [lastSelectedReport, setLastSelectedReport] = useState<ClientReportViewModel | null>(null); //AddEditClientReportDialog
    const { isAdmin } = useContext(APIContext);

    useEffect(() => {
        UpdateReportList();
    }, []);

    function UpdateReportList() {
        msalFetch('api/ClientReport/GetAllReportIds')
            .then(response => response.json())
            .then(data => {
                setData(data);
            });
    }

    function RemoveSelectedReport(selectedRow: ClientReportViewModel) {
        if (confirm('Are you sure you want to remove this client report?')) {
            selectedRow.removed = true; //set remove to true then call the update method

            msalFetch('api/ClientReport/AddUpdateClientReport/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                },
                body: JSON.stringify(selectedRow)
            })
                .then(response => response.json())
                .then((data: boolean) => {
                    if (data)
                        UpdateReportList();
                });
        }
    }

    function Close() {
        setOpen(false);
        //refreash the list
        UpdateReportList();
    }

    return (isAdmin ?
        <Paper>
            <Typography variant="h5" style={{ marginLeft: '5px' }}>Assign A Report To A Client</Typography>
            <Button style={{ float: 'right' }} variant="contained" onClick={() => { setLastSelectedReport(null); setOpen(true); }}>
                New Client Report
            </Button>
            <TextField
                fullWidth
                label="Filter By Client"
                id="filter_search"
                value={searchParams}
                style={{ marginBottom: "10px", marginTop: "10px" }}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setSearchParams(event.target.value.toLowerCase());
                }} />
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Client</TableCell>
                        <TableCell>Ops Today's Report Code</TableCell>
                        <TableCell>Ops Historic Report Code</TableCell>
                        <TableCell>Client Today's Report Code</TableCell>
                        <TableCell>Client Historic Report Code</TableCell>
                        <TableCell>Other Internal Code</TableCell>
                        <TableCell>Other External Code</TableCell>
                        <TableCell>Update</TableCell>
                        <TableCell>Remove</TableCell>
                    </TableRow>
                </TableHead>
                {/*always show default at the top of the list, and don't allow edits to default*/}
                <TableBody>
                    {data.filter(f => f.client === "Default").map((row) =>
                        <React.Fragment key={row.id}>
                            {row.client.toLowerCase().includes(searchParams) &&
                                <TableRow key={row.id}>
                                    <TableCell>{row.client}</TableCell>
                                    <TableCell>{row.todayGuid}</TableCell>
                                    <TableCell>{row.historicGuid}</TableCell>
                                    <TableCell>{row.clientTodayGuid}</TableCell>
                                    <TableCell>{row.clientHistoricGuid}</TableCell>
                                    <TableCell>{row.internalOtherLinksGuid}</TableCell>
                                    <TableCell>{row.externalOtherLinksGuid}</TableCell>
                                    <TableCell/>
                                    <TableCell/>
                                </TableRow>
                            }
                        </React.Fragment>
                    )}
                    {data.filter(f => f.client !== "Default").map((row) =>
                        <React.Fragment key={row.id}>
                            {row.client.toLowerCase().includes(searchParams) &&
                                <TableRow key={row.id}>
                                    <TableCell>{row.client}</TableCell>
                                    <TableCell>{row.todayGuid}</TableCell>
                                    <TableCell>{row.historicGuid}</TableCell>
                                    <TableCell>{row.clientTodayGuid}</TableCell>
                                    <TableCell>{row.clientHistoricGuid}</TableCell>
                                    <TableCell>{row.internalOtherLinksGuid}</TableCell>
                                    <TableCell>{row.externalOtherLinksGuid}</TableCell>
                                    <TableCell>
                                        <IconButton style={{ marginLeft: '6px', padding: '0px' }}
                                            onClick={() => { setLastSelectedReport(row); setOpen(true); }}>
                                            <Tooltip title={<>Update Selected Report</>}>
                                                <UpdateIcon />
                                            </Tooltip>
                                        </IconButton>
                                    </TableCell>
                                    <TableCell>
                                        <IconButton style={{ marginLeft: '6px', padding: '0px' }}
                                            onClick={() => { setLastSelectedReport(row); RemoveSelectedReport(row); }}>
                                            <Tooltip title={<>Delete Selected Report</>}>
                                                <DeleteIcon />
                                            </Tooltip>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            }
                        </React.Fragment>
                    )}
                </TableBody>
            </Table>
            <AddEditClientReportDialog onClose={Close} open={open} clientReportModel={lastSelectedReport} />
        </Paper>
        :
        <Fragment />
    );
}